import { EMPTY_ARRAY } from 'commons-ui';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES, ESegmentStatus, ESegmentType } from 'constant';
import _get from 'lodash/get';

interface RowData {
	deployedOnWebsite?: boolean;
	state?: string;
	isRapid?: boolean;
	createdAt?: string;
	allowRapidJobExecution?: boolean;
	SegmentType?: string;
	segmentId?: number;
}

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: EMPTY_ARRAY,
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: (rowData: any) => {
					const { deployedOnWebsite } = rowData;
					if (deployedOnWebsite) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.userSegment,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateSegment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'View',
				id: 'view',
				isEnabled: (rowData: any) => {
					const { deployedOnWebsite } = rowData;
					if (deployedOnWebsite) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.userSegment,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].viewSegment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Delete',
				id: 'delete',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.userSegment,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].deleteSegment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Force Delete',
				id: 'forceDelete',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.userSegment,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].forceDeleteSegment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Activate',
				id: 'activate',
				isEnabled: (rowData: any) => {
					const state = rowData?.state;
					if (!state || state === ESegmentStatus.ACTIVE) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.userSegment,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].activateSegment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Run',
				id: 'run',
				isEnabled: (rowData: RowData) => {
					const state = rowData?.state;
					const isRapid: boolean = _get(rowData, 'isRapid', false);
					const segmentType: string = rowData?.SegmentType || '';

					if (
						state === ESegmentStatus.DRAFT ||
						segmentType === ESegmentType.LIVE_SEGMENT ||
						segmentType === ESegmentType.DERIVED_SEGMENT
					) {
						return false;
					}

					const hasSegmentRunPermission: boolean = hasPermission({
						entity: DASHBOARD_RESOURCES.userSegment,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].runSegment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});

					const hasNonRapidSegmentRunPermission: boolean = hasPermission({
						entity: DASHBOARD_RESOURCES.userSegment,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].nonRapidRunSegment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});

					return isRapid ? hasSegmentRunPermission : hasNonRapidSegmentRunPermission;
				}
			},
			{
				name: 'Schedule',
				id: 'schedule',
				isEnabled: (rowData: RowData) => {
					const state = rowData?.state;
					const segmentType: string = rowData?.SegmentType || '';
					const isRapid: boolean = _get(rowData, 'isRapid', false);

					if (
						state === ESegmentStatus.DRAFT ||
						segmentType === ESegmentType.LIVE_SEGMENT ||
						segmentType === ESegmentType.DERIVED_SEGMENT
					) {
						return false;
					}

					const hasSegmentSchedulePermission: boolean = hasPermission({
						entity: DASHBOARD_RESOURCES.userSegment,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].scheduleSegment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});

					const hasNonRapidSegmentSchedulePermission: boolean = hasPermission({
						entity: DASHBOARD_RESOURCES.userSegment,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].nonRapidScheduleSegment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});

					return isRapid ? hasSegmentSchedulePermission : hasNonRapidSegmentSchedulePermission;
				}
			}
		],
		addAction: {
			name: 'Add Segment',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.userSegment,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].createSegment,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
